/* eslint-disable react-hooks/exhaustive-deps */
import i18next from "i18next";
import { Button, Popover } from "antd";
import { Link } from "react-router-dom";
import { CloseOutlined } from "@ant-design/icons";
import { CustomIcon } from 'datastake-daf/dist/components';
import { addEdge, removeElements } from "react-flow-renderer";
import React, { useCallback, useEffect, useState } from "react";
import { Node } from './Node';
import { NodeInformationStyle } from './style';
import { subjectsSharedLabels, } from './config';
import { fitView, onVisibleChange } from "../flow";
import { useModule } from "../user";

export function useNodes({
  items,
  type,
  setActiveNode = () => { },
  t = (s) => s,
  user = null,
  ownDataSource = true,
  subjectType = 'source',
  mB = true,
  changeSourceId = () => { },
  changeSelectedProject = () => { },
  projectDatastakeId = null,
  setPopoverVisible = () => { },
}) {
  const { mod } = useModule();

  const [X, Y] = type === 'RL' ? [-290, -100] : [290, -100];
  const [initElements, setInitElements] = useState();
  const [elements, setElements] = useState([]);
  const [instance, setInstance] = useState(null);

  const renderPopOver = useCallback((activeNode, click) => {
    const setSourceId = () => {
      if (activeNode) {
        if (activeNode.userId) {
          if (activeNode.userId) {
            localStorage.setItem('source', activeNode.userId);
            changeSourceId(activeNode.userId);
          }
        }
      }
    };

    const editOwnDataClicked = () => {
      localStorage.removeItem('project');
      changeSelectedProject('myOwnData');
    };
    if (activeNode) {
      const getHeader = (node) => (
        <div className="header">
          <div className="content">
            <label className="id">{node?.id}</label>
            <label className="label">{node?.label}</label>
          </div>
        </div>
      );
      const getBody = () => {
        switch (activeNode.type) {
          case 'lir':
            return (
              <div className="main">
                {getHeader(activeNode.parentConfig)}
                <div className="lir-sources">
                  <label className="s-label">
                    {t('Local information Relays')}
                    <Popover
                      title={null}
                      content={<div style={{ maxWidth: 150 }}>{t('Dashboard::lirText')}</div>}
                      placement="bottom"
                      onOpenChange={onVisibleChange}
                    >
                      <span>&#9888;&#65039;</span>
                    </Popover>
                  </label>
                  <div className="items">
                    {activeNode.published ? activeNode.sources.map((s, i) => (
                      <div className="item" key={i.toString()}>
                        <label>
                          <a target="_blank" rel="noopener noreferrer" href={`/app/${mod || 'pme'}/view/lir/${s.id}`}>
                            {s.name}
                          </a>
                        </label>
                      </div>
                    )) : (
                      <div className="item">
                        <p>
                          🔒 {t('Source has not disclosed this information')}.
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          default:
            return (
              <>
                <div className="main">
                  {getHeader(activeNode)}
                  {(activeNode.subjectsShared && activeNode.subjectsShared.length > 0) && (
                    <div className="subjects-shared">
                      <label className="s-label">{t('Subjects Shared')}</label>
                      <div className="items">
                        {activeNode.subjectsShared.map((i, j) => (
                          <div className='tag' key={`${i}-${j}`}>{t(subjectsSharedLabels[i])}</div>
                        ))}
                      </div>
                    </div>
                  )}
                  {Array.isArray(activeNode.applications) && (
                    <div className='applications'>
                      <label className="s-label">{t('Applications')}</label>
                      <div className='apps-list'>
                        {activeNode.applications.includes('pme') && (
                          <div className='app-cont'>
                            <div className='icon-cont pme'>
                              <CustomIcon name="PmeIcon" width={12} height={12} />
                            </div>
                            <div className='label'>
                              Datastake PME
                            </div>
                          </div>
                        )}
                        {activeNode.applications.includes('cadd') && (
                          <div className='app-cont'>
                            <div className='icon-cont cadd'>
                              <CustomIcon name="CaddIcon" width={12} height={12} />
                            </div>
                            <div className='label'>
                              Datastake CADD
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {!!activeNode.lastPublished && (
                    <div className="last-published">
                      <label className="s-label">{t('Last Published')}</label>
                      <p>{activeNode.lastPublished || '-'}</p>
                    </div>
                  )}
                </div>
              </>
            );
        }
      };

      const getActions = (node) => {
        return (
          <div className="actions">
            {node.type === 'ownData' ? (
              <div className="flex flex-column mt-2">
                {projectDatastakeId && (
                  <Link style={{ display: 'flex' }} to={`/app/${mod || 'pme'}/project/${projectDatastakeId}/publications`}>
                    <Button style={{ flex: 1 }} type="primary">{t('Publish to project')}</Button>
                  </Link>
                )}
                {mB ? (
                  <Button
                    onClick={editOwnDataClicked}
                    type="default"
                    style={{ borderColor: '#D0D5DD' }}
                    className="mt-1"
                  >
                    {t('Edit Own Data')}
                  </Button>
                ) : (
                  <Button
                    onClick={setSourceId}
                    type="default"
                    style={{ borderColor: 'var(--mmt-primary-70)' }}
                  >
                    {t('View Own Data')}
                  </Button>
                )}
              </div>
            ) : (mB && node.userId && node.type !== 'supplyChainActor') ? (
              <Button
                onClick={setSourceId}
                type="primary"
                className="mt-2"
                disabled={mod === 'cadd'}
              >
                {t('View Source Data')}
              </Button>
            ) : null}
          </div>
        )
      }
      return (
        <NodeInformationStyle>
          <div className="close-cont">
            <CloseOutlined onClick={click} />
          </div>
          {getBody()}
          {getActions(activeNode)}
        </NodeInformationStyle>
      );
    }
  }, [t, projectDatastakeId]);

  const onElementsRemove = (elementsToRemove) =>
    setElements((els) => removeElements(elementsToRemove, els));

  const onConnect = (params) => setElements((els) => addEdge({
    ...params, type: 'buttonedge',
  }, els));

  const onLoad = (reactFlowInstance) => {
    setTimeout(() => fitView(reactFlowInstance.fitView), 100);
    setInstance(reactFlowInstance);
  };

  const setAllPositions = (nodes) => {
    const groupedByLevel = {};
    let ownData;

    nodes.forEach((n) => {
      if (n.level !== 0) {
        if (groupedByLevel[n.level]) {
          groupedByLevel[n.level].push(n);
        } else {
          groupedByLevel[n.level] = [n];
        }
      } else {
        ownData = n;
      }
    });

    const elements = [ownData];
    Object.entries(groupedByLevel).forEach(([k, v]) => {
      let group = [];
      const maxChildY = ((v.length + 1) * (Y / 2));

      if (k === '1') {
        let lirInc = 0;
        v.forEach((el, i) => {
          if (el && el.config && el.config.type === 'lir') {
            lirInc += 10;
          }
          group.push({
            ...el,
            position: {
              x: X,
              y: maxChildY - (Y * (i + 1)) + lirInc,
            }
          });
        });
      } else {
        const parentX = groupedByLevel[k - 1][0].position.x;
        v.forEach((el, i) => {
          group.push({
            ...el,
            position: {
              x: parentX + X,
              y: maxChildY - (Y * (i + 1)),
            },
          });
        });
      }

      elements.push(...group);
      groupedByLevel[k] = group;
    });

    return elements;
  };

  const initializeItems = (items) => {
    let nodes = [];
    let connections = {};
    const ownData = items.ownData;
    let lirId = 1;

    const pushChildrens = (id, childrens, parentLevel) => {
      if (childrens.length > 0) {
        let childrensWithChildrens = [];
        let parentConnections = [];

        childrens.forEach((ch, i) => {
          if (!ch) {
            return;
          }
          let parentConfig;
          let childId = ch.id;
          if (ch.parentId) {
            const par = nodes.find((n) => n.id === ch.parentId || n?.config?.id === ch.parentId);
            if (par) {
              parentConfig = par.config;
            }
          }

          if (ch.type === 'lir') {
            lirId += 1;
            childId = `LIR-${lirId}`;
          } else {
            childId = `${childId}-${i}-${subjectType}`;
          }

          nodes.push({
            id: childId,
            data: { label: ch.label || '' },
            type: 'node',
            source: id,
            config: { ...ch, parentConfig },
            isHidden: false,
            toggled: (ch.childrens && ch.childrens.length > 0) ? true : undefined,
            // isHidden: parentLevel === 0 ? false : true,
            // toggled: (ch.childrens && ch.childrens.length > 0) ? false : undefined,
            level: parentLevel + 1,
          });

          parentConnections.push(childId);

          if (ch.childrens && ch.childrens.length) {
            childrensWithChildrens.push(({ ...ch, childId }));
          }
        });
        connections[id] = parentConnections;

        if (childrensWithChildrens.length > 0) {
          childrensWithChildrens.forEach((ch) => {
            pushChildrens(ch.childId, ch.childrens, parentLevel + 1);
          });
        }
      }
    };

    if (ownData) {
      nodes.push({
        id: ownData.id,
        sourcePosition: 'left',
        position: { x: 0, y: 0 },
        type: 'node',
        toggled: ownData.childrens.length > 0 ? true : undefined,
        config: { ...ownData, type: 'ownData' },
        level: 0,
      });
      pushChildrens(ownData.id, ownData.childrens, 0);
    }

    let edges = [];
    Object.keys(connections).forEach((k) => {
      const source = k;
      const values = connections[k];
      values.forEach((val) => {
        const node = nodes.find((n) => n.id === val);
        edges.push({
          id: `${source}-${val}`,
          source,
          target: val,
          type: 'edge',
          isHidden: node.isHidden,
          level: node.level,
        });
      });
    });

    nodes = setAllPositions(nodes);
    setInitElements([
      ...nodes,
      ...edges,
    ]);
  };

  useEffect(() => {
    if (user) {
      if (items) {
        initializeItems(items);
      } else {
        setInitElements([]);
      }
    }
  }, [items, user]);

  useEffect(() => {
    if (initElements) {
      const filteredElements = initElements.filter((i) => !i.isHidden);
      setElements(filteredElements.map((el) => {
        switch (el.type) {
          case 'edge':
            if (!ownDataSource) {
              if (el.source === items?.ownData?.id) {
                return {
                };
              }
            }

            return {
              id: el.id,
              source: el.source,
              type: 'buttonedge',
              target: el.target,
              animated: false,
              style: {
                stroke: 'var(--mmt-primary-60)',
              }
            };
          case 'node':
            const _type = el?.config?.type === 'ownData' ? 'ownData' : subjectType || '';

            return {
              id: el.id,
              isLir: el.config.type === 'lir',
              data: {
                label: (
                  <Node
                    setPopoverVisible={setPopoverVisible}
                    renderPopOver={renderPopOver}
                    el={el}
                    _type={_type}
                    t={t}
                  />
                ),
              },
              style: el.id === 'fakeOwnData' ? {
                height: 70,
                width: 200,
                zIndex: -1,
                padding: 0,
              } : el.config.type === 'lir' ? {
                borderRadius: 20,
                height: 30,
                width: 200,
                padding: 0,
              } : {
                height: 70,
                width: 200,
                padding: 0,
              },
              className: 'node',
              position: el.position,
              sourcePosition: type === 'RL' ? 'left' : 'right',
              targetPosition: type === 'RL' ? 'right' : 'left',
            };
          default:
            return null;
        }
      }));
    }
  }, [initElements]);

  useEffect(() => {
    setActiveNode(null);
  }, [i18next.language]);

  useEffect(() => {
    if (instance) {
      setTimeout(() => fitView(instance.fitView), 100);
    }
  }, [elements]);

  return {
    elements,
    initElements,
    onElementsRemove,
    onConnect,
    onLoad,
  };
}
